import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../../../../core/defaultValues";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { resetALL } from "../../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../../core/logManager";

const INIT_STATE = {
  loading: false,
  locations: [],
  total: 0,
  error: null,
};

const route = "modules/workOrders/views/main/components/locationTab/redux/slice.";

const workOrdersSearchLocations = createAsyncThunk(
  "workOrders/trackerTab/workOrdersSearchLocations",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        workOrdersSearchLocations.query,
        {
          conditions,
          sort,
          limit,
          offset: offset > -1 ? offset : 0,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchCustomerLocations");
      return rejectWithValue(exc);
    }
  }
);

workOrdersSearchLocations.query = `
    query ($conditions: [CustomerLocationSearchInput], $sort: [CustomerLocationSortInput], $limit: Int, $offset: Int) {
        data: searchCustomerLocations(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
            total
            items {
                id
                name
                customerId
                locationType
                contact
                address
                latitude
                longitude
                createdOn
            }
        }
    }
`;

export { workOrdersSearchLocations };

//Slice
const workOrdersLocationTabRedux = createSlice({
  name: "workOrders/locationTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //workOrdersSearchLocations
    builder.addCase(workOrdersSearchLocations.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(workOrdersSearchLocations.fulfilled, (state, action) => {
      state.loading = false;
      state.locations = action.payload.items;
      state.total = action.payload.total;
    });
    builder.addCase(workOrdersSearchLocations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersLocationTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
